// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__3PspQ","container":"Layout_container__2dNm8"};